export const getForm = (formName) => async (dispatch) => {
  try {
    const action = { type: "GET_FORM", payload: formName };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};
